import {NgModule} from "@angular/core";
import {Routes, RouterModule} from "@angular/router";
import {BrowseComponent} from "@app/modules/browse/browse.component";
import {LoginComponent} from "@app/modules/login/login.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "/browse",
    pathMatch: "full",
  },
  {
    path: "browse",
    component: BrowseComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "**",
    redirectTo: "/browse",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
